<template>
    <div id="Activity" class="container arrangement">
        <Progress :stage="2"/>
        <a-collapse accordion activeKey="0" v-if="hasData">
            <a-collapse-panel
                v-for="(date, index) in sortedDate"
                :header="renderTitle(date, index)" :key="index">
                <div class="arrangement-list">
                    <div class="arrangement-box"
                         v-for="(subItem, index) in activityObj[date]"
                         :key="'subitem_' + index"
                         :class="{active: currentActivityObj[subItem.id]}"
                    >
                        <div class="arrangement-check">
                            <a-tooltip placement="bottomLeft" v-if="!subItem.access">
                                <template slot="title">
                                    <span>{{getLabel('ACTIVITY_NO_ACCESS')}}</span>
                                </template>
                                <a-checkbox :disabled="!subItem.access"></a-checkbox>
                            </a-tooltip>
                            <a-checkbox v-if="subItem.access"
                                        :checked="selectList.indexOf(subItem.id) !== -1"
                                        @change="e=>handleActivityCheck(e, subItem.id)"
                            >
                            </a-checkbox>
                            <span style="margin-left: 5px;">{{getAmPm(subItem)}} {{subItem.start_time}}</span>
                        </div>
                        <div class="arrangement-main">
                            <p class="arrangement-title" @click="setCurrentActivity(subItem.id)">
                                {{language === 'zh' ? subItem.zh_name : subItem.en_name}}
                            </p>
                            <div v-if="currentActivityObj[subItem.id]">
                                <p class="arrangement-introduction">
                                    {{language === 'zh' ? subItem.introduction : subItem.en_introduction}}
                                </p>
                                <p class="arrangement-cell arrangement-location">
                                    {{language === 'zh' ? subItem.zh_address : subItem.en_address}}
                                </p>
                                <p class="arrangement-cell arrangement-clock">{{subItem.start_time}} - {{subItem.end_time}}</p>
                                <p class="arrangement-cell arrangement-user">{{subItem.chairman_one || ''}} {{subItem.chairman_two || ''}} {{subItem.chairman_three || ''}}</p>
                                <div class="arrangement-img">
                                    <img v-for="(pic,index) in subItem.pic_urls" :src="pic.url" :key="'img_' + index"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </a-collapse-panel>

        </a-collapse>
        <div class="btn-group">
            <a-button type='default' size="large" @click="backToSummary" v-if="isSecondEnter">{{getLabel('TIP_CANCEL')}}</a-button>
            <a-button type='primary' size="large" class="btn-orange" @click="prevStep" v-if="!isSecondEnter">{{getLabel('BUTTON_PREV')}}</a-button>
            <a-button type='default' size="large" @click="skipStep" v-if="!isSecondEnter">{{getLabel('BUTTON_SKIP')}}</a-button>
            <a-button type='primary' size="large" @click="nextStep">{{getLabel('BUTTON_NEXT')}}</a-button>
        </div>
    </div>
</template>

<script>
	import {mapState} from 'vuex';
	import Progress from '../components/Progress';
	import Language from '../util/language';
	import Controller from '../components/Controller';

	export default {
		components: {
			Progress
		},
        mixins: [Controller],
		data () {
			return {
                listCurrent: {},
                currentActivityObj: {},
                initSelectList: [],
                editSelectList: []
			}
		},
		mounted() {
			this.resetListCurrent();
			if (!this.hasData) {
				this.$store.dispatch('activity/getActivity');
            }
            this.$store.commit('activity/resetShadowSelectList');
			if (this.isSecondEnter) {
				this.initSelectList = JSON.parse(JSON.stringify(this.selectList));
			}
		},
		computed: {
			...mapState({
				language: state => state.main.language,
				residence_city: state => state.main.currentUser.residence_city,
				is_lecture: state => state.main.currentUser.is_lecture,
				charge_type: state => state.main.currentUser.charge_type,
                hasData: state => state.activity.hasData,
				activityObj: state => state.activity.activityObj,
				sortedDate: state => state.activity.sortedDate,
				selectList: state => state.activity.shadowSelectList,
				dateWeekMap: state => state.activity.dateWeekMap,
				isSecondEnter: state => state.main.isSecondEnter
			})
		},
		watch: {
			sortedDate: function () {
				this.resetListCurrent();
			}
		},
		methods: {
			// 获取描述
			getLabel: function (key) {
				return Language(this.language, key);
			},
            // 设置当前查看的活动
			setCurrentActivity: function (id) {
				let currentActivityObj = this.currentActivityObj;
				if (!currentActivityObj[id]) {
					currentActivityObj[id] = 1;
                } else {
					currentActivityObj[id] = 0;
                }
                this.currentActivityObj = Object.assign({}, currentActivityObj);
            },
            // 节标题
            renderTitle: function (date, index) {
	            const zhWeeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
	            const enWeeks = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
				let prefix = this.language === 'zh' ? `第 ${index + 1} 天` : `Day ${index + 1}`;
				let weekDay = this.dateWeekMap[date];
				if (isNaN(weekDay) || weekDay < 0 || weekDay > 6) {
					return `${prefix} | ${date} `;
                } else {
					return `${prefix} | ${date} ${this.language === 'zh' ? zhWeeks[weekDay] : enWeeks[weekDay]}`;
                }
            },
            // 上下午
			getAmPm: function (item) {
				if (this.language === 'zh') {
					return item.am ? '上午' : '下午';
				} else {
					return item.am ? 'A.M' : 'P.M';
				}
            },
            // 重置当前开始时间索引
            resetListCurrent: function () {
	            let _listCurrent = {};
	            this.sortedDate.map((date) => _listCurrent[date] = 0);
	            this.listCurrent = _listCurrent;
            },
            // 活动勾选
			handleActivityCheck:function (e, id) {
				this.$store.commit('activity/activitySelect', {
					type: e.target.checked ? 'add' : 'remove',
                    id
                });
            },
            // 上一步
            prevStep: function () {
                if (this.language === 'zh') {
                	this.$router.push('/information');
                } else {
	                this.$router.push('/en/information');
                }
            },
            // 跳过
			skipStep: function () {
				if (this.isSecondEnter) {
					this.backToSummary();
				} else {
					let targetModule = '';
					if (this.residence_city === 1) {
						targetModule = 'summary';
                    } else {
						targetModule = this.charge_type === 1 ? 'flight' : 'hotel';
                    }
					if (this.language === 'zh') {
						this.$router.push(`/${targetModule}`);
					} else {
						this.$router.push(`/en/${targetModule}`);
					}
				}
			},
			// 下一步
			nextStep: function () {
				if (this.selectList.length < 1) {
					this.$store.commit('main/openMessage', {
						type: 'warning',
						message: this.getLabel('ACTIVITY_NO_SELECT')
					}, { root: true });
					return;
                }
				this.$store.dispatch('activity/updateSelect', this.nextPage);
			},
            // 返回汇总页
			backToSummary: function () {
				this.$store.commit('activity/setSelectList', this.initSelectList);
				this.$store.commit('main/backToSummary');
			}
		}
	};
</script>

<style lang="less" scoped>
    .arrangement {
        &-list {
            position: relative;
            -ms-overflow-style: none;
            overflow: -moz-scrollbars-none;
            &::-webkit-scrollbar { width: 0 !important }
        }
        &-box {
            padding: 15px 25px 15px 40px;
            &:nth-last-child(1) {
                margin-bottom: 0;
                border-bottom: none;
            }
            &.active {
                background: #FFF;
                border-radius: 2px;
                margin-bottom: 10px;
                &:hover {
                    box-shadow: 0 2px 20px 1px rgba(0,0,0,0.22);
                }
            }
        }
        &-check {
            line-height: 24px;
            float: left;
        }
        &-main {
            margin-left: 130px;
        }
        &-title {
            cursor: pointer;
            font-size: 16px;
            color: #00A0ED;
        }
        &-introduction {
            text-align: justify;
            font-size: 14px;
            color: #666;
            margin: 10px 74px 20px 5px;
        }
        &-cell {
            color: #333;
            margin-bottom: 20px;
            padding-left: 30px;
        }
        &-location {
            background: url(../assets/img/location.png) left center no-repeat;
            background-size: 19px;
        }
        &-clock {
            background: url(../assets/img/activity_clock.png) left center no-repeat;
            background-size: 19px
        }
        &-user {
            background: url(../assets/img/activity_user.png) left center no-repeat;
            background-size: 19px;
        }
        &-img img {
            display: inline-block;
            width: 240px;
            height: 124px;
            margin-right: 20px;
            border-radius: 4px;
            &:nth-last-child(1) {
                margin-right: 0;
            }
        }
    }
</style>
<style lang="less">
    #Activity .ant-collapse {
        border: none;
        border-radius: 0;
        background: none;
        &-item {
            border: none;
            margin-bottom: 10px;
            border-radius: 0;
        }
        &-header {
            height: 40px;
            line-height: 40px;
            padding: 0 20px;
            color: #333;
            font-size: 16px;
            background: #BCE0FB;
        }
        .arrow {
            display: none;
        }
        .ant-collapse-content {
            overflow: visible;
            position: relative;
            border-top: none;
            background: none;
            padding-top: 15px;
        }
        .ant-collapse-content-box {
            padding: 16px 0;
        }
    }
    .ant-tooltip-placement-bottom .ant-tooltip-arrow {
        /*border-bottom-color: #D8D8D8;*/
    }
    .ant-tooltip-inner {
        /*font-size: 12px;*/
        /*color: #666666;*/
        /*background: #FFF;*/
        /*border: 1px solid #D8D8D8;*/
        /*border-radius: 4px;*/
        font-size: 12px;
        /*max-width: 125px;*/
    }
</style>
